// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gj-datepicker{width: 100%}


.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
    
    vertical-align: middle;
}
#recent-reports{
    table-layout: fixed;
    width: 100%
}
#recent-reports th:first-child{
    width: 138px;
}
#recent-reports th:nth-child(2){
    width: 180px;
}
#recent-reports th:nth-child(3){
    width: 273px;
}
#recent-reports th:nth-child(4){
    width: 180px;
}
#recent-reports th:nth-child(5){
    width: 106px;
}
#recent-reports th:last-child{
    width: 150px;
}
#recent-reports tbody tr.report-plan-a{
    background: #f5f5f5;
}
.ngx-datepicker-calendar-container .ngx-datepicker-position-bottom-right{
    width: 260 px;
}


.report-plan-arrow{
    border-radius: 50%;
    height: 30px;
    width: 30px;
    text-align: center;
    padding: 6px 9px;
}
.padding0{
    padding: 0px;
}
.rounded-num{
    background: #00a6c6;
    padding: 3px 5px;
    color: #fff;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
}
.report-action-btn span{
    background: #00a6c6;
    padding: 5px;
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
    cursor: pointer;
}
.report-plan-arrow{
    border-color: #00a6c6;
    color: #00a6c6;float: right;
}
.text-wrap{
    white-space: nowrap;
    width: 12em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
}
.all-customer{
    height: auto !important;
    border-radius: 3px;
}
.btn-continue{
    border: 1px solid transparent;
}
.setting-model{
    margin-top: 10%;
}
.glyphicon.glyphicon-time{    font-size: 24px;
    top: 5px;}
    .report-action-btn{float: left;}

    .table-responsive{
        max-height: 495px;
        min-height: 86px;
        overflow-y: scroll;
    }
    .calinput{padding: 0;
        width: 100%;
        margin-bottom: 6px;}
        .calinput input{width: 88%;}
        .ui-inputtext {
            margin: 0;
            outline: medium none;
            padding: .25em;
            font-weight: normal;
            width: 88%;
            height: 36px;
            border-radius: 18px 0 0 18px !important;
        }
.navbar-nav>li>a{

    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    font-size: 13px;
    margin-left: -7px;
        
}
 .nav>li>a>img {
    max-width: none;
    width: 32px;
    margin-right: 0px;
    margin-bottom: 3px;

}

.draft{
    background:#9A0A35;
  }

  .space-right{
      padding-right: 2px;
  }

  .all-cust-bor{
    border-radius: 17px;
  }

  .all-cust-btn-bor{
    border-radius: 17px;
  }



  .pointer{
	cursor: pointer;
}
#head_class{
	background: white ;
}

.selectCustomerDropDown {
	width: 95%;
	border-radius: 20px;
	border: 1px solid #ccc; 
	box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
	transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
	height: 35px;
	/* color: #3d7576; */
	color: black;
	text-align: center;
	
}

#customerOptions {
	background-color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/dashboard.component.css"],"names":[],"mappings":"AAAA,eAAe,WAAW;;;AAG1B;;IAEI,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB;AACJ;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;;;AAGA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,cAAc,CAAC,YAAY;AAC/B;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,eAAe;AACnB;AACA,8BAA8B,eAAe;IACzC,QAAQ,CAAC;IACT,mBAAmB,WAAW,CAAC;;IAE/B;QACI,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;IACtB;IACA,UAAU,UAAU;QAChB,WAAW;QACX,kBAAkB,CAAC;QACnB,gBAAgB,UAAU,CAAC;QAC3B;YACI,SAAS;YACT,oBAAoB;YACpB,cAAc;YACd,mBAAmB;YACnB,UAAU;YACV,YAAY;YACZ,uCAAuC;QAC3C;AACR;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;;AAErB;CACC;IACG,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;EACpB;;EAEA;MACI,kBAAkB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;;;EAIA;CACD,eAAe;AAChB;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,mBAAmB;CACnB,sBAAsB;CACtB,2EAA2E;CAC3E,qEAAqE;CACrE,YAAY;CACZ,oBAAoB;CACpB,YAAY;CACZ,kBAAkB;;AAEnB;;AAEA;CACC,uBAAuB;AACxB","sourcesContent":[".gj-datepicker{width: 100%}\r\n\r\n\r\n.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {\r\n    \r\n    vertical-align: middle;\r\n}\r\n#recent-reports{\r\n    table-layout: fixed;\r\n    width: 100%\r\n}\r\n#recent-reports th:first-child{\r\n    width: 138px;\r\n}\r\n#recent-reports th:nth-child(2){\r\n    width: 180px;\r\n}\r\n#recent-reports th:nth-child(3){\r\n    width: 273px;\r\n}\r\n#recent-reports th:nth-child(4){\r\n    width: 180px;\r\n}\r\n#recent-reports th:nth-child(5){\r\n    width: 106px;\r\n}\r\n#recent-reports th:last-child{\r\n    width: 150px;\r\n}\r\n#recent-reports tbody tr.report-plan-a{\r\n    background: #f5f5f5;\r\n}\r\n.ngx-datepicker-calendar-container .ngx-datepicker-position-bottom-right{\r\n    width: 260 px;\r\n}\r\n\r\n\r\n.report-plan-arrow{\r\n    border-radius: 50%;\r\n    height: 30px;\r\n    width: 30px;\r\n    text-align: center;\r\n    padding: 6px 9px;\r\n}\r\n.padding0{\r\n    padding: 0px;\r\n}\r\n.rounded-num{\r\n    background: #00a6c6;\r\n    padding: 3px 5px;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    width: 25px;\r\n    height: 25px;\r\n    display: inline-block;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n}\r\n.report-action-btn span{\r\n    background: #00a6c6;\r\n    padding: 5px;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n}\r\n.report-plan-arrow{\r\n    border-color: #00a6c6;\r\n    color: #00a6c6;float: right;\r\n}\r\n.text-wrap{\r\n    white-space: nowrap;\r\n    width: 12em;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n.all-customer{\r\n    height: auto !important;\r\n    border-radius: 3px;\r\n}\r\n.btn-continue{\r\n    border: 1px solid transparent;\r\n}\r\n.setting-model{\r\n    margin-top: 10%;\r\n}\r\n.glyphicon.glyphicon-time{    font-size: 24px;\r\n    top: 5px;}\r\n    .report-action-btn{float: left;}\r\n\r\n    .table-responsive{\r\n        max-height: 495px;\r\n        min-height: 86px;\r\n        overflow-y: scroll;\r\n    }\r\n    .calinput{padding: 0;\r\n        width: 100%;\r\n        margin-bottom: 6px;}\r\n        .calinput input{width: 88%;}\r\n        .ui-inputtext {\r\n            margin: 0;\r\n            outline: medium none;\r\n            padding: .25em;\r\n            font-weight: normal;\r\n            width: 88%;\r\n            height: 36px;\r\n            border-radius: 18px 0 0 18px !important;\r\n        }\r\n.navbar-nav>li>a{\r\n\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n    padding-left: 0px;\r\n    font-size: 13px;\r\n    margin-left: -7px;\r\n        \r\n}\r\n .nav>li>a>img {\r\n    max-width: none;\r\n    width: 32px;\r\n    margin-right: 0px;\r\n    margin-bottom: 3px;\r\n\r\n}\r\n\r\n.draft{\r\n    background:#9A0A35;\r\n  }\r\n\r\n  .space-right{\r\n      padding-right: 2px;\r\n  }\r\n\r\n  .all-cust-bor{\r\n    border-radius: 17px;\r\n  }\r\n\r\n  .all-cust-btn-bor{\r\n    border-radius: 17px;\r\n  }\r\n\r\n\r\n\r\n  .pointer{\r\n\tcursor: pointer;\r\n}\r\n#head_class{\r\n\tbackground: white ;\r\n}\r\n\r\n.selectCustomerDropDown {\r\n\twidth: 95%;\r\n\tborder-radius: 20px;\r\n\tborder: 1px solid #ccc; \r\n\tbox-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);\r\n\ttransition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;\r\n\theight: 35px;\r\n\t/* color: #3d7576; */\r\n\tcolor: black;\r\n\ttext-align: center;\r\n\t\r\n}\r\n\r\n#customerOptions {\r\n\tbackground-color: black;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
